webpackJsonp([70144966829960],{

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _config = __webpack_require__(10);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _PageTitle = __webpack_require__(22);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleSubmit = function handleSubmit(e) {
	  e.preventDefault();
	
	  var textInputValue = document.getElementById("name").value;
	  var messageInputValue = document.getElementById("message").value;
	  var phoneInputValue = document.getElementById("phone").value;
	
	  console.log(textInputValue);
	  console.log(messageInputValue);
	  console.log(phoneInputValue);
	
	  var xhr = new XMLHttpRequest();
	  xhr.open("POST", "https://3jdtraap46.execute-api.us-east-1.amazonaws.com/Beta/comments", true);
	  xhr.setRequestHeader('Content-Type', 'application/json');
	  xhr.send(JSON.stringify({
	    name: textInputValue,
	    message: messageInputValue,
	    phone: phoneInputValue
	  }));
	  document.getElementById("commentsForm").reset();
	};
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'wpforms-container-full' },
	    _react2.default.createElement(_PageTitle2.default, { title: 'Contact' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      ' Leave us a message below. If you want us to videochat you, please also leave a phone number!'
	    ),
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit, id: 'commentsForm', className: 'wpforms-form' },
	      _react2.default.createElement('input', { placeholder: 'Your name', id: 'name' }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('input', { placeholder: 'Phone number', id: 'phone' }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('textarea', { placeholder: 'Message', id: 'message', rows: '4', cols: '30' }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'button',
	        null,
	        'Send'
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-e645a1c0ca114a7433c7.js